export const PDP_SIDERAIL_SELLER_REVIEW_COMBINED_MARCH_2026 =
    'PDP_SiderailSellerReviewCombined_March2026';
export const PDP_ESTIMATE_SIMILAR_SOLD_TEST_NAME = 'PDP_1stDibsEstimateSimilarSold_Oct2025';
export const PDP_PERSONALIZED_DYNAMIC_CATALOGUE_DEC_2025 =
    'PDP_PersonalizedDynamicCatalogue_Dec2025';
export const NEW_ARRIVALS_TEST_NAME = 'Browse_NewArrivalsLogic_Feb2026';
export const PDP_SIMILAR_SOLD_ITEMS_MODULE_TEST_NAME = 'PDP_SimilarSoldPill_Feb2026';
export const PDP_LARGER_ITEMS_MAR_2026 = 'PDP_ImageGalleryUX_March2026';
export const PDP_BUTTON_STYLE_MAR_2026 = 'PDP_ButtonTest_March2026';
export const PDP_TRUST_MESSAGING_TEST_NAME = 'PDP_TrustMessagingTest1_April2026';
